import { render, staticRenderFns } from "./CreateWorkerCategory.vue?vue&type=template&id=05ea2d30&scoped=true"
import script from "./CreateWorkerCategory.vue?vue&type=script&lang=js"
export * from "./CreateWorkerCategory.vue?vue&type=script&lang=js"
import style0 from "./CreateWorkerCategory.vue?vue&type=style&index=0&id=05ea2d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ea2d30",
  null
  
)

export default component.exports